"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventCreator = void 0;
function EventCreator(eventIdGenerator, options) {
    function createEvent(platform, props) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var screenInfo, deviceInfo, osInfo, browserInfo, userId, deviceId, embeddedDomain, event;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, platform.screenInfo()];
                    case 1:
                        screenInfo = _d.sent();
                        return [4 /*yield*/, platform.deviceInfo()];
                    case 2:
                        deviceInfo = _d.sent();
                        return [4 /*yield*/, platform.osInfo()];
                    case 3:
                        osInfo = _d.sent();
                        return [4 /*yield*/, platform.browserInfo()];
                    case 4:
                        browserInfo = _d.sent();
                        return [4 /*yield*/, platform.getUserId()];
                    case 5:
                        userId = _d.sent();
                        return [4 /*yield*/, platform.getDeviceId(options === null || options === void 0 ? void 0 : options.embeddedOptions)];
                    case 6:
                        deviceId = _d.sent();
                        embeddedDomain = platform.getEmbeddedDomain(options === null || options === void 0 ? void 0 : options.embeddedOptions);
                        /**
                         * In an embedded context, we prefix deviceId with the
                         * embedded identifier to allow us to prefix match events by
                         * either `embedded` standalone, or `embedded:aol` (example)
                         * to find all embedded events for a particular org.
                         **/
                        if ((_a = options === null || options === void 0 ? void 0 : options.embeddedOptions) === null || _a === void 0 ? void 0 : _a.identifier) {
                            // Our platform-specific functions _should not_ do this, but we
                            // check if they have prefixed our device ID with `embedded::` already.
                            if (!deviceId.startsWith('embedded::')) {
                                deviceId = "embedded::" + options.embeddedOptions.identifier + "::" + deviceId;
                            }
                        }
                        _c = { eventId: eventIdGenerator.generateEventId(), timestamp: new Date(), deviceId: deviceId,
                            userId: userId, isEmbedded: Boolean((options === null || options === void 0 ? void 0 : options.embeddedOptions.identifier) || (options === null || options === void 0 ? void 0 : options.embeddedOptions.token)), embeddedIdentifier: options === null || options === void 0 ? void 0 : options.embeddedOptions.identifier, embeddedToken: options === null || options === void 0 ? void 0 : options.embeddedOptions.token, embeddedUserId: (options === null || options === void 0 ? void 0 : options.embeddedOptions.identifier) ? 'will-be-replaced' : undefined, embeddedDomain: embeddedDomain };
                        return [4 /*yield*/, platform.getPartnerId()];
                    case 7:
                        event = __assign.apply(void 0, [(_c.partnerId = _d.sent(), _c.deviceType = deviceInfo.type, _c.deviceModel = deviceInfo.model, _c.deviceVendor = deviceInfo.vendor, _c.osName = (_b = osInfo.name) !== null && _b !== void 0 ? _b : 'unknown', _c.osVersion = osInfo.version, _c.screenWidth = screenInfo.width, _c.screenHeight = screenInfo.height, _c.screenOrientation = screenInfo.orientation, _c.userAgent = browserInfo.userAgent, _c.browserName = browserInfo.name, _c.browserVersion = browserInfo.version, _c), props]);
                        return [2 /*return*/, event];
                }
            });
        });
    }
    return {
        createEvent: createEvent,
    };
}
exports.EventCreator = EventCreator;
//# sourceMappingURL=event-creator.js.map